// Styles
import styles from './DepartmentsTitle.module.css';

export const DepartmentsTitle = ({titleName}) => {
  return(
    <h2 className={styles.title}>{titleName}</h2>
  );
};